

























































































































import _ from "lodash";
import "devextreme/dist/css/dx.light.css";
import { Component, Vue, Prop } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import {
  Contractor,
  Fee,
  Maintenancejob,
  Property,
  SelectOption,
} from "@/models";
import TaskModal from "@/components/modals/TaskModal.vue";
@Component({
  components: {
    TaskModal,
  },
})
export default class JobDetails extends Vue {
  @Prop({ default: false }) public showsidebar: boolean;

  @Getter("maintenancejobs/hasUnsavedChanges")
  public hasUnsavedChanges: boolean;
  @Getter("auth/isBaseUser") public isBaseUser: boolean;

  @Getter("maintenancejobs/current") public maintenancejob: Maintenancejob;
  @Getter("maintenancejob/list") public list: Property[];

  @Getter("maintenancejobs/list") public maintenancejoblist: Maintenancejob[];

  @Mutation("maintenancejobs/setCurrent")
  public setCurrent: (maintenancejob: Maintenancejob) => void;

  @Action("maintenancejobs/getMaintenancejob")
  public getMaintenancejob: (id: string) => Promise<Maintenancejob>;
  @Action("maintenancejobs/setMaintenancejobDeep")
  public setMaintenancejobDeep: (payload: {
    path: string;
    data: any;
  }) => Promise<any>;

  @Action("maintenancejobs/addMaintenancejob")
  public addMaintenancejob: (maintenancejob: Maintenancejob) => Promise<any>;

  @Action("contractors/getContractors") getContractors: () => Promise<void>;
  public contractorOptions: SelectOption[] = [];
  @Getter("contractors/list") public contractorlist: Contractor[];

  @Action("maintenancejobs/updateMaintenancejob")
  public updateMaintenancejob: (maintenancejob: Maintenancejob) => Promise<any>;
  @Mutation("maintenancejobs/addUnsavedChange")
  public addUnsavedChange: (id: string) => Promise<any>;
  // Computed property to filter fees by status and contractor
  get fees() {
    return this.maintenancejob.invoice.fees.filter((f: Fee) => {
      const matchesStatus = this.filterStatus
        ? f.status === this.filterStatus
        : true;      
      // const matchesContractor = this.filterContractor.slug
      //   ? f.contractor === this.filterContractor.slug
      //   : true;
      return matchesStatus;
    });
  }
  set fees(data: Fee[]) {
    this.setMaintenancejobDeep({
      path: "invoice.fees",
      data,
    });
  }
  public statusOptions: string[] = [
    "New",
    "Unallocated",
    "Allocated",
    "In Progress",
    "On Hold",
    "Completed",
  ];

  public addNewFee(): void {
    this.maintenancejob.invoice.fees = this.maintenancejob.invoice.fees.concat([
      new Fee(),
    ]);
    let modal: any = this.$refs.taskmodel as any;
    modal.init(this.maintenancejob.invoice.fees.length - 1, "Add");
    document.body.appendChild(modal.$el);
    ($(modal.$el) as any).modal("show");
  }
  public async mounted() {
    await Promise.all([this.getContractors()])
      .then(() => {
        this.setContractorOptions();
      })
      .catch((err: any) => this.$onecentral.displayError(err));
  }

  public EditFee($index: number): void {
    let modal: any = this.$refs.taskmodel as any;
    modal.init($index, "Edit");
    document.body.appendChild(modal.$el);
    ($(modal.$el) as any).modal("show");
  }
  public removeFee(): void {
    this.maintenancejob.invoice.fees = this.$onecentral.removeItemByIndex(
      this.maintenancejob.invoice.fees,
      this.deletefeeindex
    );
  }
  public showDeleteDialog(index: number) {
    this.deletefeeindex = index;
    this.removeFee();
    let modal: any = this.$refs.taskmodel as any;
    modal.init(-1, "Edit");
  }
  public deletefeeindex: number = -1;
  public clearStatus($index: number): void {
    this.setMaintenancejobDeep({
      path: `invoices[${$index}].type`,
      data: "",
    });
  }
  public filterStatus: string = "";
  // Event handler for when a status is selected
  public onStatusSelect(newStatus: string) {
    this.filterStatus = newStatus; // Triggering reactivity in fees
  }
  public clearStatusfilter() {
    this.filterStatus = "";
  }
  public clearContractor() {
    this.filterContractor = new SelectOption();
  }
  public filterContractor: SelectOption = new SelectOption();
  public async setContractorOptions() {
    this.contractorOptions = this.contractorlist.map((c: Contractor) => {
      return { name: c.companyName, slug: c.id };
    });
  }
  public onContractorSelect(val: SelectOption) {
    this.filterContractor = val; // Triggering reactivity in fees
  }
  public givenContractorNames(ids: string[]): string {
    if (!ids || ids.length === 0) {
      return '';
    }

    return this.contractorlist
      .filter((contractor: Contractor) => ids.includes(contractor.id))
      .map((contractor: Contractor) => contractor.companyName)
      .join(', '); // Combine into a single string
  }

}
